import { Capacitor } from '@capacitor/core'

/**
 * Composable for app information (name, platform, version)
 * @returns {Object} Object containing getAppName, getPlatform, getAppVersion, getNativePlatform
 */
export function useAppInfo() {
  /**
   * Get the application name
   * @returns {string} Application name
   */
  const getAppName = () => {
    return import.meta.env.VITE_APP_NAME || ''
  }

  /**
   * Get the current platform
   * @returns {string} Platform name (e.g., 'android', 'ios', 'web')
   */
  const getNativePlatform = () => {
    if (Capacitor.isNativePlatform()) {
      return Capacitor.getPlatform()
    }
    return null
  }

  const getPlatform = () => {
    if (import.meta.env.VITE_MOBILE_APP) {
      const nativePlatform = getNativePlatform()
      if (nativePlatform) return nativePlatform
      return 'MobileApp'
    }
    return 'Web'
  }

  /**
   * Get the application version
   * @returns {string} Application version
   */
  const getAppVersion = () => {
    return import.meta.env.VITE_APP_VERSION
  }
  return {
    getAppName,
    getPlatform,
    getAppVersion,
    getNativePlatform
  }
}
